module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_05_on.ba4ae97e.svg";